import { DomainError } from '@/errors';

export class UpdateBookingAddOnsError extends DomainError {}
